export const Posts = [
  {
    id: 1,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Arcu nulla ac vitae rhoncus, metus donec ultricies et sed. Eleifend amet nibh donec amet dignissim mauris elementum. Quam lectus at id amet massa auctor. Urna vestibulum velit ornare integer posuere nec. Pulvinar fermentum etiam in lacus. Dictumst viverra adipiscing leo, venenatis magna molestie. At odio lectus tempor tortor adipiscing. Turpis nunc augue facilisi quis faucibus enim arcu. this is additional text, you will never notice. this project is made by awesome people called genius.",
    writer: {
      name: "김수한무거북이와두루미",
      job: "브랜드 디자이너",
      photo: "",
    },
    view: 20,
    date: "2021-12-08",
    location: "안산시 상록구 푸른동",
    heart: 12,
    comments: [
      {
        name: "김수한무",
        content: "리액트 개고수가 되고 싶어요!",
        reply: [
          {
            name: "김수한무거북이와두루미",
            content: "공식 문서 위주로 자바스크립트부터 공부하세요",
          },
        ],
      },
      {
        name: "지나가던사람",
        content: "강의 하나 추천해드릴까요?",
      },
    ],
  },
  {
    id: 2,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Arcu nulla ac vitae rhoncus, metus donec ultricies et sed. Eleifend amet nibh donec amet dignissim mauris elementum. Quam lectus at id amet massa auctor. Urna vestibulum velit ornare integer posuere nec. Pulvinar fermentum etiam in lacus. Dictumst viverra adipiscing leo, venenatis magna molestie. At odio lectus tempor tortor adipiscing. Turpis nunc augue facilisi quis faucibus enim arcu.",
    writer: {
      name: "김수한무거북이와두루미",
      job: "브랜드 디자이너",
      photo: "",
    },
    view: 20,
    date: "2021-12-08",
    location: "안산시 상록구 푸른동",
    heart: 12,
  },
  {
    id: 3,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Arcu nulla ac vitae rhoncus, metus donec ultricies et sed. Eleifend amet nibh donec amet dignissim mauris elementum. Quam lectus at id amet massa auctor. Urna vestibulum velit ornare integer posuere nec. Pulvinar fermentum etiam in lacus. Dictumst viverra adipiscing leo, venenatis magna molestie. At odio lectus tempor tortor adipiscing. Turpis nunc augue facilisi quis faucibus enim arcu.",
    writer: {
      name: "김수한무거북이와두루미",
      job: "브랜드 디자이너",
      photo: "",
    },
    view: 20,
    date: "2021-12-08",
    location: "안산시 상록구 푸른동",
    heart: 12,
  },
  {
    id: 4,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Arcu nulla ac vitae rhoncus, metus donec ultricies et sed. Eleifend amet nibh donec amet dignissim mauris elementum. Quam lectus at id amet massa auctor. Urna vestibulum velit ornare integer posuere nec. Pulvinar fermentum etiam in lacus. Dictumst viverra adipiscing leo, venenatis magna molestie. At odio lectus tempor tortor adipiscing. Turpis nunc augue facilisi quis faucibus enim arcu.",
    writer: {
      name: "김수한무거북이와두루미",
      job: "브랜드 디자이너",
      photo: "",
    },
    view: 20,
    date: "2021-12-08",
    location: "안산시 상록구 푸른동",
    heart: 12,
  },
  {
    id: 5,
    content:
      "가야 할 때가 언제인가를 분명히 알고 가는 이의 뒷모습은 얼마나 아름다운가. 봄 한 철 격정을 인내한 나의 사랑은 지고 있다. 분분한 낙화. 결별이 이룩하는 축복에 싸여 지금은 가야 할 때 무성한 녹음과 그리고 머지않아 열매 맺는 가을을 향하여 나의 청춘은 꽃답게 죽는다. 헤어지자 섬세한 손길을 흔들며 하롱하롱 꽃잎이 지는 어느 날 나의 사랑, 나의 결별 샘터에 물 고이듯 성숙하는 내 영혼의 슬픈 눈.",
    writer: {
      name: "김수한무거북이와두루미",
      job: "브랜드 디자이너",
      photo: "",
    },
    view: 20,
    date: "2021-12-08",
    location: "안산시 상록구 푸른동",
    heart: 12,
  },
];
